module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./install.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/install.md
// module id = 0aZB
// module chunks = 0